import React from "react";
import { Animate } from "react-simple-animate";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import "./styles.scss";
import Resume from "../../resum/yresume.pdf";



const Home = () => {
  return (
    
    <section className="home" id="home">
      <div className="home__text-wrapper">
        <h1>
          Hey, I'm Yashasweni..
          <br />
          the Technological Artist
        </h1>
      </div>
      <Animate
        play
        duration={1.5}
        delay={1}
        start={{
          transform: "translateY(600px)",
        }}
        end={{
          transform: "translateX(0px)",
        }}
      >
        <div className="contact-me">
          <div className="contact-me__buttons-wrapper">
            <a href="mailto:2020meb1334@iitrpr.ac.in">Hire me</a>
            <a href={Resume}>Download resume</a>
           
          </div>
          <div className="contact-me__socials-wrapper">
           <a href="https://www.linkedin.com/in/yashasweni-mathur-a9bb78214?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BfOm45vBEQNWKT%2FEm9U1bwQ%3D%3D"> <FaLinkedin size={32} /></a> 
           <a href="https://github.com/Ishum123">  <FaGithub size={32} /></a>
           
          </div>
        </div>
      </Animate>
    </section>
  );
};

export default Home;
